import { loadBillingCharges, loadContracts, loadServiceOffers } from 'api/services/accessControlOperationsService'
import PageLoading from 'components/common/loading/PageLoading'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { Link } from 'react-router-dom'

const TenantArea = () => {
  const { t } = useTranslation()
  const contractsQ = useQuery(['tenantContracts'], loadContracts)
  const chargesQ = useQuery(['tenantCharges'], loadBillingCharges)
  const offersQ = useQuery(['tenantServiceOffers'], loadServiceOffers)

  if (contractsQ.isLoading || chargesQ.isLoading || offersQ.isLoading) return <PageLoading />

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 space-y-4">
      <h1 className="text-2xl font-bold text-imovSecondary">{t('accessControl.tenantArea.title')}</h1>
      <p className="text-sm text-gray-600">
        {t('accessControl.tenantArea.description')}
      </p>
      <div className="grid gap-3 sm:grid-cols-3">
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <p className="text-xs text-gray-500">{t('accessControl.labels.contracts')}</p>
          <p className="text-xl font-semibold">{contractsQ.data?.length ?? 0}</p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <p className="text-xs text-gray-500">{t('accessControl.labels.charges')}</p>
          <p className="text-xl font-semibold">{chargesQ.data?.length ?? 0}</p>
        </div>
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <p className="text-xs text-gray-500">{t('accessControl.labels.serviceMarketplace')}</p>
          <p className="text-xl font-semibold">{offersQ.data?.length ?? 0}</p>
        </div>
      </div>
      <div className="rounded-xl border border-gray-200 bg-white p-4 text-sm">
        <Link to="/listings" className="text-imovPrimary hover:underline">
          {t('accessControl.tenantArea.searchListings')}
        </Link>
      </div>
    </div>
  )
}

export default TenantArea

